import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';

import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import IntegrationInfo from './IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import Switch from 'rc-switch';
import {
  API_StandAlonePage_Connection,
  gAPI_Ingetration,
  gAPI_Property_List,
  dAPI_Delete_Ingetration,
  gAPI_MembershipTags,
} from '../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import Example from './Example';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Layout from './StandaloneLayout';
import EmbedVoucherCodeSnippet from './EmbedCodeSnippet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette,faBorderAll,faFont,faLanguage,faShare, faSearch } from '@fortawesome/free-solid-svg-icons';
import DigitalAssistant from './StandaloneDigitalAssistant';
import StandAloneCodeSnippet from './StandAloneCodeSnippet';
import StandAloneFonts from './StandAloneFonts';
import CustomEmails from './customEmails';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import StandaloneSocialSharing from './StandalonePage/SocialSharing';
import PdfAttachment from './StandalonePage/PdfAttachment';
import StandaloneFeatures from './StandaloneFeatures';
import AivaAppearanceImage from '../../../../../assets/aiva_appearance_image.png';
import AivaEmailImage from '../../../../../assets/aiva_email_image.png';
import AivaLayoutImage from '../../../../../assets/aiva_layout_image.png';
import AivaSocialImage from '../../../../../assets/aiva_social_image.png';
import AivaFeaturesImage from '../../../../../assets/aiva_features_image.png';
import SEOSettings from './StandalonePage/SEOSettings';
import Validation from '../../../../../components/Validation';
function VoucherStandAlonePageIntegrationList({ match, history, propertyId,propertyData }) {  
  const integrationId = match.params.id;
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const [fontsVisible, setFontsVisible] = useState(false);
  let [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(false);
  const [layoutVisible, setLayoutVisible] = useState(false);  
  const [positionVisible, setPositionVisible] = useState(false);    
  const [apperanceVisible, setApperanceVisible] = useState(false);
  const [pdfAttachment, setPdfAttachment] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);  
  const [emailVisible,setEmailVisible]=useState(false);
  const [featuresVisible,setFeaturesVisible]=useState(false);
  const [socialShahringVisible,setSocialSharingVisible]=useState(false);
  const [SEOSettingsVisible,setSEOSettingsVisible] = useState(false);
  const [membershipTags,setMembershipTags]=useState([]);
  const localeOptions = [
    { id: "en", name: "English", desc: "English", code: "en", locale: "en" },
    { id: "hi", name: "Hindi", desc: "हिंदी", code: "hi", locale: "hi" },
    {
      id: "id",
      name: "Indonesian",
      desc: "bahasa Indonesia",
      code: "id",
      locale: "id",
    },
    { id: "es", name: "Spanish", desc: "Español", code: "es", locale: "es" },
    { id: "fr", name: "French", desc: "français", code: "fr", locale: "fr" },
    { id: "de", name: "German", desc: "Deutsche", code: "de", locale: "de" },
    { id: "zh", name: "Chinese", desc: "简体中文", code: "ZH-簡", locale: "zh" },
    {
      id: "vi",
      name: "Vietnamese",
      desc: "Tiếng Việt",
      code: "vi",
      locale: "vi",
    },
    { id: "th", name: "Thai", desc: "ไทย", code: "th", locale: "th" },
    { id: "ja", name: "Japanese", desc: "日本語", code: "ja", locale: "ja" },
    {
      id: "zh-TW",
      name: "Chinese (Traditional)",
      desc: "繁體中文",
      code: "ZH-繁",
      locale: "hk",
    },
    {
      id: "tl",
      name: "Tagalog (Filipino)",
      desc: "Tagalog (Filipino)",
      code: "tl",
      locale: "tl",
    },
    { id: "af", name: "Afrikaans", desc: "Afrikaans", code: "af", locale: "af" },
    { id: "ko", name: "Korean", desc: "한국어", code: "ko", locale: "ko" },
    { id: "mi", name: "Maori", desc: "Maori", code: "mi", locale: "mi" },
  ];
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const property = () => {
    setPropertyVisible(true);
    setLayoutVisible(false);
    setFontsVisible(false);
    setEmailVisible(false);
    setPdfAttachment(false);
   setPublishVisible(false);
   setApperanceVisible(false);
   setFeaturesVisible(false);
   setSocialSharingVisible(false);
   setSEOSettingsVisible(false);
  };
  const layout = () => {
    setPropertyVisible(false);
    setFontsVisible(false);
    setLayoutVisible(true);
    setEmailVisible(false);
    setPublishVisible(false);
    setApperanceVisible(false);
    setPdfAttachment(false);
    setFeaturesVisible(false);
    setSocialSharingVisible(false);
    setSEOSettingsVisible(false);
  };


  useEffect(() => {   
    AxiosAPI({
      method: 'get',
      url: `${gAPI_MembershipTags}?propertyId=${propertyId}`,
    })
      .then((res) => {        
        if(res.data!== undefined && res.data.tags !== undefined)
           setMembershipTags(res.data.tags);
           setPropertyVisible(true);
    });   
    AxiosAPI({
      method: 'get',
      url: `${API_StandAlonePage_Connection}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {                         
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
    }, [integrationId]);

    useEffect(() => {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      }).then((res) => {
        setAllProperties(res.data);
      });    
    }, []);

  const handleCustomEmails=(email)=>{
    integration.standalonePage.pageSettings.voucherEmail.email=email;
  };

  const saveIntegration = (data) => {  
    const updateModel = integration;      
    if (data.list === undefined)        
    updateModel.standalonePage = data;   
    if (data.list !== undefined)     
     {        
      updateModel.properties = data.list;
      updateModel.name = data.name;        
      updateModel.ismembership=data.isShowMembership;
      updateModel.membershipTags = data.selectedMemberShipTags.map((m)=>m.value);
     }
         
    if (data.isaivaHide !== undefined) {
      updateModel.isaivaHide = data.isaivaHide;  
      updateModel.applyPromoCode=data.applyPromoCode;
    }    
    AxiosAPI({
      method: 'put',
      url: `${API_StandAlonePage_Connection}/${integration.id
        }?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          console.log(integration);
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          NotificationManager.success(
            "",
            "Integration updated successfully",
            3000,
            null,
            null,
            "success"
          );
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      });
  };

  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_VOUCHER_URL
      }/vhp?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const publishCode = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setFontsVisible(false);    
    setPositionVisible(false);
    setEmailVisible(false);    
    setPdfAttachment(false);
    setPublishVisible(true);
    setFeaturesVisible(false);
    setApperanceVisible(false);   
    setSocialSharingVisible(false); 
    setSEOSettingsVisible(false);
  };

  
  const appearance = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setFeaturesVisible(false);
    setFontsVisible(false);
    setSocialSharingVisible(false);
    setEmailVisible(false);
    setPdfAttachment(false);
    setPublishVisible(false);
    setApperanceVisible(true);
    setSEOSettingsVisible(false);
  };
  
  const emails = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setFontsVisible(false);
    setFeaturesVisible(false);
    setSocialSharingVisible(false);
    setEmailVisible(true);
    setPublishVisible(false);
    setPdfAttachment(false);
    setSEOSettingsVisible(false);
    setApperanceVisible(false);    
  };

  const setFonts = () => {
    setPropertyVisible(false);
    setApperanceVisible(false); 
    setSocialSharingVisible(false);   
    setEmailVisible(false);
    setFontsVisible(true);
    setFeaturesVisible(false);
    setPositionVisible(false);    
    setPublishVisible(false);
    setPdfAttachment(false);
    setSEOSettingsVisible(false);
  };

  const setFeatures = ()=>{
    setPropertyVisible(false);
    setApperanceVisible(false);    
    setEmailVisible(false);
    setFontsVisible(false);
    setSocialSharingVisible(false);
    setFeaturesVisible(true);
    setPositionVisible(false);    
    setPublishVisible(false);
    setPdfAttachment(false);
    setSEOSettingsVisible(false);
  }

  const showSocialSharing=()=>{
    setPropertyVisible(false);
    setApperanceVisible(false);    
    setEmailVisible(false);
    setLayoutVisible(false);
    setFontsVisible(false);
    setSocialSharingVisible(true);
    setFeaturesVisible(false);
    setPositionVisible(false);    
    setPublishVisible(false);
    setPdfAttachment(false);
    setSEOSettingsVisible(false);
  }

  
  const showPdfAttachment=()=>{
    setPropertyVisible(false);
    setApperanceVisible(false);    
    setEmailVisible(false);
    setFontsVisible(false);
    setSocialSharingVisible(false);
    setFeaturesVisible(false);
    setPositionVisible(false);    
    setPublishVisible(false);
    setPdfAttachment(true);
    setSEOSettingsVisible(false);
  }


  const showSEOSettings=()=>{
    setPropertyVisible(false);
    setApperanceVisible(false);    
    setEmailVisible(false);
    setFontsVisible(false);
    setSocialSharingVisible(false);
    setFeaturesVisible(false);
    setPositionVisible(false);    
    setPublishVisible(false);
    setPdfAttachment(false);
    setSEOSettingsVisible(true);
  }
  


  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration');
        }, 300)
      );
  };
  
  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                         <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                             Select Businesses  
                          </p>
                          <p className="mb-4 text-small">
                             Select the businesses that are visible through this voucher store
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${featuresVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-building`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setFeatures()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Features
                          </p>
                          <p className="mb-4 text-small">
                            Select the features that are visible on the vouchers page
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                   
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${socialShahringVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-share`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showSocialSharing()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Social Sharing
                          </p>
                          <p className="mb-4 text-small">
                            Let your customers spread the world
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>            
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${pdfAttachment ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-file`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showPdfAttachment()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Email & Attachment
                          </p>
                          <p className="mb-4 text-small">
                            Customize the voucher email & pdf attachment
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>            
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${layoutVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-building`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => layout()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select layout
                          </p>
                          <p className="mb-4 text-small">
                            Select the layout that are visible through this
                            integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                   
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${apperanceVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faPalette} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => appearance()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Appearance
                          </p>
                          <p className="mb-4 text-small">
                            Choose your digital assistant's name, avatar and
                            setup your colours
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration  ${emailVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => emails()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Custom Emails
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages for the chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${fontsVisible == true ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFont} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setFonts()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Custom Fonts
                          </p>
                          <p className="mb-4 text-small">
                            Control the fonts of aiva widget on your website
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  
                  <div
                    className={`mb-3 integration ${SEOSettingsVisible == true ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faSearch} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showSEOSettings()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                              SEO Settings
                          </p>
                          <p className="mb-4 text-small">
                             Boost your voucher store’s SEO with Meta description
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publishCode()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                             Publish your Vouchers & eGift Store
                          </p>
                          <p className="mb-4 text-small">
                              Get to unique URL for your Digital Store
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
            {emailVisible && (
                <Fragment>
                  <CustomEmails
                    handleCustomEmails={handleCustomEmails}
                    integration={integration}
                    integrationProperties={integration.standalonePage.pageSettings}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                    botSettings={integration.standalonePage.pageSettings}
                  />
                               
                </Fragment>
              )}
            {apperanceVisible && (
                <Fragment>
                  <DigitalAssistant
                    integration={integration}
                    botSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    allProperties={allProperties}
                    propertyId={propertyId}
                  />
                  <Example url={AivaAppearanceImage} />
                </Fragment>
              )}
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    membership={membershipTags}
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />                  
                </Fragment>
              )}
              {fontsVisible && (
                <Fragment>
                  <StandAloneFonts
                    botSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}                    
                    allProperties={allProperties}
                    integration={integration}
                    propertyId={propertyId}
                    saveIntegration={saveIntegration}
                  />                  
                </Fragment>
              )}
               {pdfAttachment && (
                <Fragment>
                  <PdfAttachment
                    pageSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    integration={integration}
                    propertyId={propertyId}
                    saveIntegration={saveIntegration}
                  />
                  <Example url={AivaEmailImage}/>
                </Fragment>
              )}
              {SEOSettingsVisible && (
                <Fragment>
                  <SEOSettings
                    pageSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    integration={integration}
                    propertyId={propertyId}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url={AivaEmailImage}/> */}
                </Fragment>
              )}
              {featuresVisible && (
                <Fragment>
                  <StandaloneFeatures
                    pageSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  <Example url={AivaFeaturesImage} />
                </Fragment>
              )}
              {socialShahringVisible && (
                <Fragment>
                  <StandaloneSocialSharing
                    pageSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  <Example url={AivaSocialImage} />
                </Fragment>
              )}
              {publishVisible && <StandAloneCodeSnippet propertyId={propertyId} integration={integration} />}
              {layoutVisible && (
                <Fragment>
                  <Layout
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  <Example url={AivaLayoutImage} />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId,propertyData } = settings;
  return {
    propertyId,propertyData
  };
};

export default injectIntl(connect(mapStateToProps, {})(VoucherStandAlonePageIntegrationList));
